import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";

// Full URL: /admissions/:unitId/adminPortal/checklists
//   (with optional `:itemId/edit` child for deep-linking the edit modal,
//    and `create` child for the new-item modal).
// Child routes have no component — they only drive which modal the parent
// listing renders, keeping the listing itself mounted underneath.
export default store => ({
  path: "checklists",
  component: withAsyncRouteLoading(() =>
    import(
      /* webpackChunkName: "admissions-admin-portal" */ "Admissions/features/AdminPortal/components/ChecklistsPage"
    ).then(m => m.default)
  ),
  childRoutes: [{ path: ":itemId/edit" }, { path: "create" }],
});
